import { FC, useContext, useEffect } from "react";
import Tests from "./components/Tests";
import { TestContext } from "./store/testContext";
import { ITesting } from "./types";

interface IProps {
  closeTests: () => void;
  onResult: (date: ITesting) => void;
  zIndex: number;
}

const TestsModule: FC<IProps> = ({ zIndex, closeTests, onResult }) => {
  const { state } = useContext(TestContext);
  useEffect(() => {
    onResult(state);
  }, [state]);
  return <Tests zIndex={zIndex} closeTests={closeTests} />;
};
export default TestsModule;
